import React from 'react';
import fr from 'facet-rest';
import { WorkflowLayout } from 'Components/ComponentLibrary/Organisms/WorkflowLayout/WorkflowLayout';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import {
  FDContentContainer, FDStack,
} from '@facet-wealth/design';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { LottieRel } from 'Packages/FacetCore/Experimental/RelationshipComponents/LottieRel';

export const AccountOpeningV2PendingStepLayout = () => {
  const { resource } = useMetaLayoutContext();

  return (
    <WorkflowLayout appearance={'elevated'}>
      <FDContentContainer maxWidth="sm">
        <FDStack direction={'column'} spacing={2} alignSelf={'flex-start'}>
          <MetaControlField attr={'title'} />
          <MetaControlField attr={'description'} />
          <LottieRel relationship={resource.relationship(fr.relationships.lottie.name)} />
        </FDStack>
      </FDContentContainer>
    </WorkflowLayout>
  );
};
